import { AllocateConsumerDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/init-step/allocate-consumer-date-info';
import { AllocateConsumerInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/init-step/allocate-consumers-init-step';
import { AllocateConsumerRequestV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/summary-step/allocate-consumer-request';
import { ConsumerDeskV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/allocate-consumers-from-billingitem-wizard/users-step/consumer-desk';

export interface State {
  initStep: AllocateConsumerInitStepV26;
  datesStep: AllocateConsumerDueDatesV26;
  consumerDesksStep: ConsumerDeskV26[];
  reuseAllocationStep: ConsumerDeskV26[];
  miscellaneousStep: AllocateConsumerRequestV26;
}

export const initialState: State = {
  initStep: null,
  datesStep: { activationDate: null, deactivationDate: null },
  consumerDesksStep: null,
  reuseAllocationStep: null,
  miscellaneousStep: null,
};
